// extracted by mini-css-extract-plugin
module.exports = {"loadingCourses":"Institution_loadingCourses__1LODT","noCourses":"Institution_noCourses__3YuSd","courseCount":"Institution_courseCount__7Oxu3"};